import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NivaLogo from '../components/NivaLogo';
import { apiVerifyAccessCode } from '../config/api';
import { ROUTES } from '../constants/routes';

const ACCESS_CODE_KEY = 'niva_access_code';

export function getStoredAccessCode() {
  return localStorage.getItem(ACCESS_CODE_KEY) || '';
}

export function setStoredAccessCode(code) {
  localStorage.setItem(ACCESS_CODE_KEY, code);
}

export function clearStoredAccessCode() {
  localStorage.removeItem(ACCESS_CODE_KEY);
}

export default function AccessCodeScreen() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const normalized = code.trim().toUpperCase();
    if (!normalized) return;

    setVerifying(true);
    setError('');

    try {
      localStorage.setItem(ACCESS_CODE_KEY, normalized);
      await apiVerifyAccessCode();
      navigate(ROUTES.LOGIN, { replace: true });
    } catch (err) {
      clearStoredAccessCode();
      if (err.status === 401) {
        setError('Invalid code. Please check with Abdul.');
      } else if (err.status === 0) {
        setError('Could not reach the server. Run npm start and try again.');
      } else {
        setError('Could not connect. Check your internet connection.');
      }
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center bg-white px-4 py-10">
      <NivaLogo className="mb-10" />

      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-card">
        <h1 className="text-center text-[20px] font-bold text-gray-900">Enter Access Code</h1>
        <p className="mt-2 text-center text-sm leading-relaxed text-gray-600">
          You need an access code to use Sawtna. Contact admin to receive yours.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <input
            type="text"
            value={code}
            onChange={(e) => {
              setCode(e.target.value.toUpperCase());
              if (error) setError('');
            }}
            placeholder="Enter your code"
            autoCapitalize="characters"
            autoComplete="off"
            spellCheck={false}
            className="w-full rounded-xl border border-gray-200 px-4 py-3 text-center text-lg tracking-[4px] uppercase focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          />

          {error && <p className="text-center text-sm text-critical">{error}</p>}

          <button
            type="submit"
            disabled={!code.trim() || verifying}
            className="btn-primary w-full disabled:cursor-not-allowed disabled:opacity-60"
          >
            {verifying ? (
              <span className="inline-flex items-center gap-2">
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                Verifying...
              </span>
            ) : (
              'Continue'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
